import React from 'react';
import { Box } from 'grommet';

interface AdminToolProps {
  className?: string;
  children: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
}

const AdminTool: React.FC<AdminToolProps> = ({
  children,
  className = 'admin-tool',
  size = 'small',
}) => {
  const sizeMap = {
    small: '30%',
    medium: '63%',
    large: '100%',
  };

  return (
    <Box
      border={{ side: 'all', color: 'gray-200' }}
      className={className}
      pad="medium"
      round="xsmall"
      width={sizeMap[size]}
    >
      {children}
    </Box>
  );
};

export default AdminTool;
